import { tint } from "polished";
import { FC, ReactNode } from "react";
import styled from "styled-components";

const CardButtonWrapper = styled.div`
	padding: 5px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	color: ${props => tint(props.hidden ? 0.6 : 0, props.theme.colors.greenVitat || props.theme.colors.secondary)};
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: normal;
`;

const CardButtonIconWrapper = styled.div`
	float: left;
	margin-right: 5px;
`;

interface CardButtonProps {
	label: string;
	icon?: ReactNode;
	disabled?: boolean;
	handleClick?: () => void;
}

const CardButton: FC<CardButtonProps> = ({ icon, label, disabled = false, handleClick }) => {
	return (
		<CardButtonWrapper onClick={disabled ? undefined : handleClick} hidden={disabled}>
			{icon && <CardButtonIconWrapper>{icon}</CardButtonIconWrapper>}
			{label}
		</CardButtonWrapper>
	);
};

export default CardButton;
